export function isCSSUnits(value) {
    return ['px', '%'].includes(value);
}
//# sourceMappingURL=css-units.js.map